import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	done: {
		id: 'work-management-board.board.column.card.card-content.card-tick.done',
		defaultMessage: 'Done',
		description: 'Tooltip around an icon indicating whether a work item is completed',
	},
});
